import taskService from 'resources/task/task.service';
import { extendTasksWithDocuments } from 'resources/task/task.operations';


export const extendMilestonesWithTasks = async (milestones) => {
  const milestoneIds = milestones.map((milestone) => milestone.id);
  const tasks = await taskService.getMilestonesTasks(milestoneIds) || [];
  const tasksWithDocuments = await extendTasksWithDocuments(tasks);

  const milestonesWithTasks = milestones.map((milestone) => {
    const milestoneTasks = tasksWithDocuments.filter((task) => task.milestone_id === milestone.id);
    return { ...milestone, tasks: milestoneTasks };
  });

  return milestonesWithTasks;
};
